export const regions = [
  {
    region: "africa",
    regionName: "Africa",
    regionId: "AF",
    latLng: { lat: 7.271, lng: 23.248 },
    zoom: 4,
  },
  {
    region: "asia",
    regionName: "Asia",
    regionId: "AS",
    latLng: { lat: 35.972, lng: 87.067 },
    zoom: 4,
  },
  {
    region: "caribbean",
    regionName: "Caribbean",
    regionId: "CA",
    latLng: { lat: 19.668, lng: -75.018 },
    zoom: 8,
  },
  {
    region: "central-america",
    regionName: "Central America",
    regionId: "CA",
    latLng: { lat: 13.285, lng: -87.192 },
    zoom: 8,
  },
  {
    region: "europe",
    regionName: "Europe",
    regionId: "EU",
    latLng: { lat: 48.561, lng: 17.264 },
    zoom: 5,
  },
  {
    region: "middle-east",
    regionName: "Middle East",
    regionId: "ME",
    latLng: { lat: 25.436, lng: 50.019 },
    zoom: 6,
  },
  {
    region: "oceania",
    regionName: "Oceania",
    regionId: "OC",
    latLng: { lat: -25.847, lng: 133.52 },
    zoom: 5,
  },
  {
    region: "north-america",
    regionName: "North America",
    regionId: "NA",
    latLng: { lat: 38.489, lng: -98.493 },
    zoom: 5,
  },
  {
    region: "south-america",
    regionName: "South America",
    regionId: "SA",
    latLng: { lat: -15.971, lng: -60.416 },
    zoom: 5,
  },
];
